import Pagination from "components/Pagination/TablePagination";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router";
import { getStudyGroupInvites } from "../../actions/studygroups";
import { showDeleteGroupInviteConfirmationModal } from "../../actions/mixed";
import axios from "axios";
import { API_GROUP_INVITES } from "../../constants/api";
import { toast } from "react-toastify";

const approveInvitation = (id) => axios.put(`${API_GROUP_INVITES}/${id}`);

class StudyGroupSuperhostMembersInvitations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      per_page: 20,
    };
  }

  componentDidMount() {
    const { page, per_page } = this.state;
    this.props.getStudyGroupInvites({
      page,
      per_page,
      group_id: this.props.params.id,
    });
  }

  handleDelete = (id) => {
    const { page, per_page } = this.state;

    this.props.showDeleteGroupInviteConfirmationModal({
      id,
      params: {
        page,
        per_page,
        group_id: this.props.params.id,
      },
    });
  };

  handleApprove = async (id) => {
    try {
      const { page, per_page } = this.state;
      await approveInvitation(id);
      toast.success("Invitation has been approved!");
      this.props.getStudyGroupInvites({
        page,
        per_page,
        group_id: this.props.params.id,
      });
    } catch (error) {
      console.log(error);
    }
  };

  onChangePage = (page) =>
    this.setState({ page }, () =>
      this.props.getStudyGroupInvites({
        page: this.state.page,
        per_page: this.state.per_page,
        group_id: this.props.params.id,
      })
    );

  render() {
    const {
      groupInvites: { data, count, totalPages },
      params: { id },
    } = this.props;

    const { page } = this.state;

    return (
      <div style={{ width: "80%", margin: "auto" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h3>Total invites: {count}</h3>
          <Link to={`groups/${id}/members/new`}>
            <button className="button_classic">Invite New Members</button>
          </Link>
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: "16px",
          }}
        >
          {data.map((invitation) => (
            <Invitation
              key={invitation.id}
              {...invitation}
              handleDelete={() => this.handleDelete(invitation.id)}
              handleApprove={() => this.handleApprove(invitation.id)}
            />
          ))}
        </div>
        <div style={{ marginBottom: "32px" }}>
          <Pagination
            onChangePage={this.onChangePage}
            page={page}
            total_pages={totalPages}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  groupInvites: state.studygroups.invites,
});

const mapDispatchToProps = (dispatch) => ({
  getStudyGroupInvites: (data) => dispatch(getStudyGroupInvites(data)),
  showDeleteGroupInviteConfirmationModal: (payload) =>
    dispatch(showDeleteGroupInviteConfirmationModal(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudyGroupSuperhostMembersInvitations);

const Invitation = ({
  id,
  handleDelete,
  status,
  user: { first_name, last_name, email },
  handleApprove,
}) => {
  return (
    <div
      key={id}
      style={{
        display: "flex",
        gap: "16px",
        justifyContent: "space-between",
        padding: "16px",
        outline: "1px solid gray",
        borderRadius: "12px",
      }}
    >
      <div>
        {first_name} {last_name}, {email}
      </div>
      <div>
        Status: {status}
        {status === "pending" && (
          <div style={{ display: "flex", gap: 4 }}>
            <div
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={handleDelete}
            >
              [cancel invitation]
            </div>
            <div
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={handleApprove}
            >
              [approve invitation]
            </div>
          </div>
        )}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/StudyGroupSuperhost/StudyGroupSuperhostMembersInvitations.jsx